export default "__VITE_ASSET__B6sz47fP__"